import { SortDirType } from "../../../common/SortDirType";
import { SortParams } from "../../../common/SortParams";

export const sortByFields = [
  { label: "Calendar Date", value: "CALENDAR_DATE" },
  { label: "Booking Numbers", value: "BOOKING_NUMBERS" },
  { label: "Total Spaces Booked", value: "TOTAL_SPACES_BOOKED" },
  { label: "Max Inventory Count", value: "MAX_INVENTORY_COUNT" },
  { label: "Overage Spaces Charged Count", value: "OVERAGE_SPACES_CHARGED_COUNT" },
  { label: "Buyer Company Name", value: "BUYER_COMPANY_NAME" },
  { label: "Supplier Company Name", value: "SUPPLIER_COMPANY_NAME" },
  { label: "Location Name", value: "LOCATION_NAME" },
  { label: "Overage Invoice Numbers", value: "OVERAGE_INVOICE_NUMBERS" },
  { label: "Duration Type", value: "DURATION_TYPE" },
] as const satisfies Array<{label: string, value: string}>;

export type AdminSpaceUsageSortByType = typeof sortByFields[number]['value'];

export interface AdminSpaceUsageSortParams extends SortParams {
  sortBy?: AdminSpaceUsageSortByType;
  sortDir?: SortDirType
}